/** Buffer smaller than CSS box (4K cap) — use cheaper shadows / text. */
export function useLighterCanvasEffects(canvas: HTMLCanvasElement): boolean {
  try {
    const r = canvas.getBoundingClientRect();
    return canvas.width < r.width - 0.5 || canvas.height < r.height - 0.5;
  } catch {
    return false;
  }
}

/**
 * Wraps a string into lines that fit within maxWidth pixels.
 * The ctx must already have the desired font set before calling.
 */
export function wrapCanvasText(
  ctx: CanvasRenderingContext2D,
  text: string,
  maxWidth: number,
): string[] {
  const words = text.split(' ');
  const lines: string[] = [];
  let current = '';
  for (const word of words) {
    const test = current ? `${current} ${word}` : word;
    if (ctx.measureText(test).width > maxWidth && current) {
      lines.push(current);
      current = word;
    } else {
      current = test;
    }
  }
  if (current) lines.push(current);
  return lines;
}
